
// @ts-nocheck
import locale_de_45DE_46json_475226ce from "#nuxt-i18n/475226ce";
import locale_de_45AT_46json_4a380f1a from "#nuxt-i18n/4a380f1a";
import locale_pl_45PL_46json_850f3b1f from "#nuxt-i18n/850f3b1f";
import locale_pt_45PT_46json_254580df from "#nuxt-i18n/254580df";
import locale_es_45ES_46json_74820c60 from "#nuxt-i18n/74820c60";
import locale_it_45IT_46json_98997300 from "#nuxt-i18n/98997300";
import locale_nl_45NL_46json_b117aa10 from "#nuxt-i18n/b117aa10";
import locale_cs_45CZ_46json_eadf06a1 from "#nuxt-i18n/eadf06a1";
import locale_sk_45SK_46json_46c8804e from "#nuxt-i18n/46c8804e";
import locale_hu_45HU_46json_0fdbd1f0 from "#nuxt-i18n/0fdbd1f0";
import locale_sl_45SI_46json_26d2b3f1 from "#nuxt-i18n/26d2b3f1";
import locale_hr_45HR_46json_c94401bc from "#nuxt-i18n/c94401bc";
import locale_ro_45RO_46json_daebe12d from "#nuxt-i18n/daebe12d";
import locale_bg_45BG_46json_135c050f from "#nuxt-i18n/135c050f";

export const localeCodes =  [
  "de-DE",
  "de-AT",
  "pl-PL",
  "pt-PT",
  "es-ES",
  "it-IT",
  "nl-NL",
  "cs-CZ",
  "sk-SK",
  "hu-HU",
  "sl-SI",
  "hr-HR",
  "ro-RO",
  "bg-BG"
]

export const localeLoaders = {
  "de-DE": [
    {
      key: "locale_de_45DE_46json_475226ce",
      load: () => Promise.resolve(locale_de_45DE_46json_475226ce),
      cache: true
    }
  ],
  "de-AT": [
    {
      key: "locale_de_45AT_46json_4a380f1a",
      load: () => Promise.resolve(locale_de_45AT_46json_4a380f1a),
      cache: true
    }
  ],
  "pl-PL": [
    {
      key: "locale_pl_45PL_46json_850f3b1f",
      load: () => Promise.resolve(locale_pl_45PL_46json_850f3b1f),
      cache: true
    }
  ],
  "pt-PT": [
    {
      key: "locale_pt_45PT_46json_254580df",
      load: () => Promise.resolve(locale_pt_45PT_46json_254580df),
      cache: true
    }
  ],
  "es-ES": [
    {
      key: "locale_es_45ES_46json_74820c60",
      load: () => Promise.resolve(locale_es_45ES_46json_74820c60),
      cache: true
    }
  ],
  "it-IT": [
    {
      key: "locale_it_45IT_46json_98997300",
      load: () => Promise.resolve(locale_it_45IT_46json_98997300),
      cache: true
    }
  ],
  "nl-NL": [
    {
      key: "locale_nl_45NL_46json_b117aa10",
      load: () => Promise.resolve(locale_nl_45NL_46json_b117aa10),
      cache: true
    }
  ],
  "cs-CZ": [
    {
      key: "locale_cs_45CZ_46json_eadf06a1",
      load: () => Promise.resolve(locale_cs_45CZ_46json_eadf06a1),
      cache: true
    }
  ],
  "sk-SK": [
    {
      key: "locale_sk_45SK_46json_46c8804e",
      load: () => Promise.resolve(locale_sk_45SK_46json_46c8804e),
      cache: true
    }
  ],
  "hu-HU": [
    {
      key: "locale_hu_45HU_46json_0fdbd1f0",
      load: () => Promise.resolve(locale_hu_45HU_46json_0fdbd1f0),
      cache: true
    }
  ],
  "sl-SI": [
    {
      key: "locale_sl_45SI_46json_26d2b3f1",
      load: () => Promise.resolve(locale_sl_45SI_46json_26d2b3f1),
      cache: true
    }
  ],
  "hr-HR": [
    {
      key: "locale_hr_45HR_46json_c94401bc",
      load: () => Promise.resolve(locale_hr_45HR_46json_c94401bc),
      cache: true
    }
  ],
  "ro-RO": [
    {
      key: "locale_ro_45RO_46json_daebe12d",
      load: () => Promise.resolve(locale_ro_45RO_46json_daebe12d),
      cache: true
    }
  ],
  "bg-BG": [
    {
      key: "locale_bg_45BG_46json_135c050f",
      load: () => Promise.resolve(locale_bg_45BG_46json_135c050f),
      cache: true
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/54cf104a" /* webpackChunkName: "config_i18n_46config_46ts_54cf104a" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: false,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "de-DE",
      label: "German",
      iso: "de-DE",
      files: [
        {
          path: "/builds/shop22/kik-storefront-monorepo/storefront/i18n/lang/translations/de-DE.json",
          cache: undefined
        }
      ]
    },
    {
      code: "de-AT",
      label: "German",
      iso: "de-AT",
      files: [
        {
          path: "/builds/shop22/kik-storefront-monorepo/storefront/i18n/lang/translations/de-AT.json",
          cache: undefined
        }
      ]
    },
    {
      code: "pl-PL",
      label: "Poland",
      iso: "pl-PL",
      files: [
        {
          path: "/builds/shop22/kik-storefront-monorepo/storefront/i18n/lang/translations/pl-PL.json",
          cache: undefined
        }
      ]
    },
    {
      code: "pt-PT",
      label: "Portugal",
      iso: "pt-PT",
      files: [
        {
          path: "/builds/shop22/kik-storefront-monorepo/storefront/i18n/lang/translations/pt-PT.json",
          cache: undefined
        }
      ]
    },
    {
      code: "es-ES",
      label: "Spain",
      iso: "es-ES",
      files: [
        {
          path: "/builds/shop22/kik-storefront-monorepo/storefront/i18n/lang/translations/es-ES.json",
          cache: undefined
        }
      ]
    },
    {
      code: "it-IT",
      label: "Italy",
      iso: "it-IT",
      files: [
        {
          path: "/builds/shop22/kik-storefront-monorepo/storefront/i18n/lang/translations/it-IT.json",
          cache: undefined
        }
      ]
    },
    {
      code: "nl-NL",
      label: "Netherlands",
      iso: "nl-NL",
      files: [
        {
          path: "/builds/shop22/kik-storefront-monorepo/storefront/i18n/lang/translations/nl-NL.json",
          cache: undefined
        }
      ]
    },
    {
      code: "cs-CZ",
      label: "Czech Republic",
      iso: "cs-CZ",
      files: [
        {
          path: "/builds/shop22/kik-storefront-monorepo/storefront/i18n/lang/translations/cs-CZ.json",
          cache: undefined
        }
      ]
    },
    {
      code: "sk-SK",
      label: "Slovakia",
      iso: "sk-SK",
      files: [
        {
          path: "/builds/shop22/kik-storefront-monorepo/storefront/i18n/lang/translations/sk-SK.json",
          cache: undefined
        }
      ]
    },
    {
      code: "hu-HU",
      label: "Hungary",
      iso: "hu-HU",
      files: [
        {
          path: "/builds/shop22/kik-storefront-monorepo/storefront/i18n/lang/translations/hu-HU.json",
          cache: undefined
        }
      ]
    },
    {
      code: "sl-SI",
      label: "Slovenia",
      iso: "sl-SI",
      files: [
        {
          path: "/builds/shop22/kik-storefront-monorepo/storefront/i18n/lang/translations/sl-SI.json",
          cache: undefined
        }
      ]
    },
    {
      code: "hr-HR",
      label: "Croatia",
      iso: "hr-HR",
      files: [
        {
          path: "/builds/shop22/kik-storefront-monorepo/storefront/i18n/lang/translations/hr-HR.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ro-RO",
      label: "Romania",
      iso: "ro-RO",
      files: [
        {
          path: "/builds/shop22/kik-storefront-monorepo/storefront/i18n/lang/translations/ro-RO.json",
          cache: undefined
        }
      ]
    },
    {
      code: "bg-BG",
      label: "Bulgaria",
      iso: "bg-BG",
      files: [
        {
          path: "/builds/shop22/kik-storefront-monorepo/storefront/i18n/lang/translations/bg-BG.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "de-DE",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: false,
  langDir: "lang/translations/",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  currency: "EUR",
  country: "DE",
  autoRedirectByLocale: false,
  countries: [
    {
      name: "DE",
      isoCode: "DEU",
      label: "Germany"
    },
    {
      name: "AT",
      isoCode: "AUT",
      label: "Austria"
    },
    {
      name: "BE",
      isoCode: "BEL",
      label: "Belgium"
    },
    {
      name: "BG",
      isoCode: "BGR",
      label: "Bulgaria"
    },
    {
      name: "HR",
      isoCode: "HRV",
      label: "Croatia"
    },
    {
      name: "CY",
      isoCode: "CYP",
      label: "Republic of Cyprus"
    },
    {
      name: "CZ",
      isoCode: "CZE",
      label: "Czech Republic"
    },
    {
      name: "DK",
      isoCode: "DNK",
      label: "Denmark"
    },
    {
      name: "EE",
      isoCode: "EST",
      label: "Estonia"
    },
    {
      name: "FI",
      isoCode: "FIN",
      label: "Finland"
    },
    {
      name: "FR",
      isoCode: "FRA",
      label: "France"
    },
    {
      name: "GR",
      isoCode: "GRC",
      label: "Greece"
    },
    {
      name: "HU",
      isoCode: "HUN",
      label: "Hungary"
    },
    {
      name: "IE",
      isoCode: "IRL",
      label: "Ireland"
    },
    {
      name: "IT",
      isoCode: "ITA",
      label: "Italy"
    },
    {
      name: "LV",
      isoCode: "LVA",
      label: "Latvia"
    },
    {
      name: "LT",
      isoCode: "LTU",
      label: "Lithuania"
    },
    {
      name: "LU",
      isoCode: "LUX",
      label: "Luxembourg"
    },
    {
      name: "MT",
      isoCode: "MLT",
      label: "Malta"
    },
    {
      name: "NL",
      isoCode: "NLD",
      label: "Netherlands"
    },
    {
      name: "PL",
      isoCode: "POL",
      label: "Poland"
    },
    {
      name: "PT",
      isoCode: "PRT",
      label: "Portugal"
    },
    {
      name: "RO",
      isoCode: "ROU",
      label: "Romania"
    },
    {
      name: "SK",
      isoCode: "SVK",
      label: "Slovakia"
    },
    {
      name: "SI",
      isoCode: "SVN",
      label: "Slovenia"
    },
    {
      name: "ES",
      isoCode: "ESP",
      label: "Spain"
    },
    {
      name: "SE",
      isoCode: "SWE",
      label: "Sweden"
    }
  ],
  currencies: [
    {
      name: "EUR",
      label: "Euro"
    },
    {
      name: "PLN",
      label: "Polish Zloty"
    }
  ],
  seo: true,
  autoChangeCookie: {
    currency: false,
    locale: false,
    country: false
  },
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "de-DE",
    label: "German",
    iso: "de-DE",
    files: [
      {
        path: "/builds/shop22/kik-storefront-monorepo/storefront/i18n/lang/translations/de-DE.json",
        cache: undefined
      }
    ]
  },
  {
    code: "de-AT",
    label: "German",
    iso: "de-AT",
    files: [
      {
        path: "/builds/shop22/kik-storefront-monorepo/storefront/i18n/lang/translations/de-AT.json",
        cache: undefined
      }
    ]
  },
  {
    code: "pl-PL",
    label: "Poland",
    iso: "pl-PL",
    files: [
      {
        path: "/builds/shop22/kik-storefront-monorepo/storefront/i18n/lang/translations/pl-PL.json",
        cache: undefined
      }
    ]
  },
  {
    code: "pt-PT",
    label: "Portugal",
    iso: "pt-PT",
    files: [
      {
        path: "/builds/shop22/kik-storefront-monorepo/storefront/i18n/lang/translations/pt-PT.json",
        cache: undefined
      }
    ]
  },
  {
    code: "es-ES",
    label: "Spain",
    iso: "es-ES",
    files: [
      {
        path: "/builds/shop22/kik-storefront-monorepo/storefront/i18n/lang/translations/es-ES.json",
        cache: undefined
      }
    ]
  },
  {
    code: "it-IT",
    label: "Italy",
    iso: "it-IT",
    files: [
      {
        path: "/builds/shop22/kik-storefront-monorepo/storefront/i18n/lang/translations/it-IT.json",
        cache: undefined
      }
    ]
  },
  {
    code: "nl-NL",
    label: "Netherlands",
    iso: "nl-NL",
    files: [
      {
        path: "/builds/shop22/kik-storefront-monorepo/storefront/i18n/lang/translations/nl-NL.json",
        cache: undefined
      }
    ]
  },
  {
    code: "cs-CZ",
    label: "Czech Republic",
    iso: "cs-CZ",
    files: [
      {
        path: "/builds/shop22/kik-storefront-monorepo/storefront/i18n/lang/translations/cs-CZ.json",
        cache: undefined
      }
    ]
  },
  {
    code: "sk-SK",
    label: "Slovakia",
    iso: "sk-SK",
    files: [
      {
        path: "/builds/shop22/kik-storefront-monorepo/storefront/i18n/lang/translations/sk-SK.json",
        cache: undefined
      }
    ]
  },
  {
    code: "hu-HU",
    label: "Hungary",
    iso: "hu-HU",
    files: [
      {
        path: "/builds/shop22/kik-storefront-monorepo/storefront/i18n/lang/translations/hu-HU.json",
        cache: undefined
      }
    ]
  },
  {
    code: "sl-SI",
    label: "Slovenia",
    iso: "sl-SI",
    files: [
      {
        path: "/builds/shop22/kik-storefront-monorepo/storefront/i18n/lang/translations/sl-SI.json",
        cache: undefined
      }
    ]
  },
  {
    code: "hr-HR",
    label: "Croatia",
    iso: "hr-HR",
    files: [
      {
        path: "/builds/shop22/kik-storefront-monorepo/storefront/i18n/lang/translations/hr-HR.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ro-RO",
    label: "Romania",
    iso: "ro-RO",
    files: [
      {
        path: "/builds/shop22/kik-storefront-monorepo/storefront/i18n/lang/translations/ro-RO.json",
        cache: undefined
      }
    ]
  },
  {
    code: "bg-BG",
    label: "Bulgaria",
    iso: "bg-BG",
    files: [
      {
        path: "/builds/shop22/kik-storefront-monorepo/storefront/i18n/lang/translations/bg-BG.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/